import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

type IdpGroupDeleteConfirmationModalProps = {
  onConfirm: () => void;
  name: string;
};

const IdpGroupDeleteConfirmationModal = create(function IdpGroupDeleteConfirmationModal({
  onConfirm,
  name,
}: IdpGroupDeleteConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <DeleteConfirmationModal
      title="Delete IdP group mapping"
      confirmationButtonLabel="Delete"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Removing this mapping will prevent users in the <strong>{name}</strong> group from logging
        in via your identity provider. Only proceed if you're sure this group should no longer have
        access.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showIdpGroupDeleteConfirmationModal = (props: IdpGroupDeleteConfirmationModalProps) =>
  show(IdpGroupDeleteConfirmationModal, props);
